import "../../Styles/General & MultiUse/NavLayout.css";
import { useLocation } from "react-router-dom";
import AuthNavbar from "../../Components/General & MultiUse/AuthNavbar";
import Navbar from "../../Components/General & MultiUse/Navbar";

const NavLayout = () => {
  const location = useLocation();
  const isAuthPage =
    location.pathname === "/auth/signup" ||
    location.pathname === "/auth/login" ||
    location.pathname === "/auth/forgotPassword" ||
    location.pathname === "/auth/resetPassword";

  return <div className="navLayout">{isAuthPage ? <AuthNavbar /> : <Navbar />}</div>;
};

export default NavLayout;
